import { render } from "./RvoSyncBanner.vue?vue&type=template&id=33efb342&scoped=true"
import script from "./RvoSyncBanner.vue?vue&type=script&lang=js"
export * from "./RvoSyncBanner.vue?vue&type=script&lang=js"

import "./RvoSyncBanner.vue?vue&type=style&index=0&id=33efb342&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33efb342"]])

export default __exports__